export default __webpack_public_path__ + "static/media/image_section_3.1107011c.svg";